/** @jsx jsx */
import { jsx, css } from '@emotion/react'
import { memo } from 'react'
import { Maybe } from '@vendorflow/types'
import { Box, Stack, Typography } from '@mui/material'
import PdfViewer from '.'
import { SpecialZoomLevel } from '@react-pdf-viewer/core'
import { zoomPlugin } from '@react-pdf-viewer/zoom'
import { RenderCurrentPageLabelProps, pageNavigationPlugin } from '@react-pdf-viewer/page-navigation'

import '@react-pdf-viewer/zoom/lib/styles/index.css'
import { MOBILE_BREAKPOINT } from 'constants/Styles.constants'

export const PADDING = 8

function ZoomPdfViewer({ className, src }: { className?: string; src: Maybe<string> }) {
  const zoomPluginInstance = zoomPlugin()
  const { Zoom, ZoomIn, ZoomOut } = zoomPluginInstance
  const pageNavigationPluginInstance = pageNavigationPlugin()
  const { CurrentPageLabel } = pageNavigationPluginInstance

  if (!src) return null

  return (
    <div
      className={className}
      css={css`
        height: 100%;
        width: 100%;
        display: grid;
        grid-template-rows: auto 1fr auto;
      `}
    >
      <Stack direction="row" justifyContent="center" alignItems="center">
        <ZoomOut />
        <Zoom />
        <ZoomIn />
      </Stack>
      <Box
        css={css`
          height: 100%;
          width: 100%;
          overflow: auto;
        `}
      >
        <PdfViewer
          src={src}
          defaultScale={SpecialZoomLevel.PageFit}
          plugins={[zoomPluginInstance, pageNavigationPluginInstance]}
        />
      </Box>
      <Stack padding="0.25rem" direction="row" justifyContent="center" alignItems="center">
        <CurrentPageLabel>
          {(props: RenderCurrentPageLabelProps) => (
            <Typography
              css={css`
                font-size: 1rem;

                @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
                  font-size: 0.875rem;
                }
              `}
              className="zoom-pdf-viewer__current-page"
              variant="subtitle1"
            >{`${props.currentPage + 1} of ${props.numberOfPages}`}</Typography>
          )}
        </CurrentPageLabel>
      </Stack>
    </div>
  )
}

export default memo(ZoomPdfViewer)
